import * as React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";

import { Video } from "../../types";

import { View } from "../../components/Themed";
import commonStyles, { SPACING } from "../../styles/common";

import VideoPreview from "./VideoPreview";
import VideoForm, { VideosFormProps } from "./VideoForm";
import { Space } from "../../styled-component";

export interface VideoListItemProps extends Pick<VideosFormProps, "onSave"> {
  style?: StyleProp<ViewStyle>;
  video: Video;
  disabled?: boolean;
}

function VideoListItem({ video, style, onSave, disabled }: VideoListItemProps) {
  const { url } = video;

  return (
    <View style={[style, commonStyles.gridItem]}>
      <VideoForm
        onSave={onSave}
        video={video}
        style={commonStyles.listItemPrimary}
        disabled={disabled}
      />
      <Space />
      <VideoPreview url={url} style={commonStyles.listItemAvatar} />
    </View>
  );
}

const styles = StyleSheet.create({});

export default VideoListItem;
